export enum ApplicationTaskEnum {
  UploadDocuments = 'UploadDocuments',
  SignContracts = 'SignContracts',
  References = 'References',
}
